import { render, staticRenderFns } from "./SectionUpdate.vue?vue&type=template&id=2cfbd7fb&scoped=true&"
import script from "./SectionUpdate.vue?vue&type=script&lang=js&"
export * from "./SectionUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cfbd7fb",
  null
  
)

export default component.exports